import { API_URL } from "@/config/apiurl.config";

export const KRBS_CIRCULARS_APP = {
  TOKEN: 'krbs_circular_token',
  ENCRYPTED_DATA : 'vuex-krbs_circular',
  ENCRYPTED_SECRET : 'AdjIawtoiuRSjfHyh9Ed',
};

export const KRBS_CIRCULARS = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  CIRCULAR_ISSUES:{
    ALL:'/circular_issues/',
    KEYS:'/circular_issues/keys',
    KEYS_ARCHIVE:'/circular_issues/keys/archive'
  },
  CIRCULARS:{
    SEARCH:'/circulars',
    SEARCH_ATTACHMENTS:'/circularAttachments',
    ADD:'/circulars/create',
    UPDATE:'/circulars/update',
    DELETE:'/circulars/delete',
    GET_CIRCULAR_SUBJECTS:'/circular_subject',
  },
  CIRCULAR_CATEGORIES:{
    MENU:'/circular_categories/menu'

  },

  CIRCULAR_ATTACHMENTS:{
    ADD:'/circular_attachments/add',
    UPDATE:'/circular_attachments/update',
    DELETE:'/circular_attachments/delete'
  },

  /**crews routes**/

  //Report 1
  MANNING_REPORTS: '/manningReport',

  //Report 2
  CREWS: '/crews',
  CREW_CIRCULAR_LOGS: '/crew_logs',
  VIEW_CREW_CIRCULAR_LOGS: '/activity',


},
  GET_MANNING_KEYS = 'getManningKeys',
  GET_CREW_PER_MANNING_REPORT = 'getCrewPerManningReport',
  GET_LAST_MEMO_VIEWED_REPORT = 'getLastMemoViewedReport',
  CHANGE_USER_PASSWORD = 'changeUserPassword',
  GET_CREW_LAST_MEMO_VIEWED_REPORT = 'crew/getLastMemoViewedReport',
  TV_URL    = `/krbs_trainingvideo/public`,
  TTOS_URL  = `/krbs_ttos/public`,
    // ${SERVER_URL}

    SELECTED_CIRCULAR=1
;

export default {KRBS_CIRCULARS};
